// Hooks
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { useFeatures, getEnabledFeatures } from '../../hooks/features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'getAmbassador'];

export function useGetAmbassador(personId: string) {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useQuery({
    enabled: !!personId,
    queryKey: MUTATION_PREFIX.concat([personId ?? '']),
    queryFn: async () => {
      return await client.getAmbassadorByPersonId({ personId: personId });
    },
  });
}
